// import {set, toggle} from '../../..//utils/vuex'

export default {
    pushTicketToCart(state, place) {
        state.items.push(place);
    },
    spliceTicketFromCart(state, {id}) {
        let cartItemIndex = state.items.findIndex(item => item.id === id);
        state.items.splice(cartItemIndex, 1)
    },
}
